"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWaitlistPhoneNumberContainer = exports.StyledWaitlistPhoneNumberInformation = exports.StyledWaitlistSection = exports.StyledWaitlistPhoneInputLabel = exports.StyledWaitlistPhoneInputContainer = exports.StyledWaitlistDescription = exports.StyledWaitlistHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledWaitlistHeader = styled_1.default.h2 `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.StyledWaitlistDescription = styled_1.default.p `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin-bottom: 0;
`;
exports.StyledWaitlistPhoneInputContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.StyledWaitlistPhoneInputLabel = styled_1.default.label `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.StyledWaitlistSection = styled_1.default.section `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.StyledWaitlistPhoneNumberInformation = (0, styled_1.default)(exports.StyledWaitlistDescription) ``;
exports.StyledWaitlistPhoneNumberContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map